import React from 'react';
import './LegalPage.css';

const TermsConditions = () => {
  return (
    <section className="legal-page">
      <div className="container">
        <div className="legal-header">
          <span className="section-tag">📋 Legal</span>
          <h1>Terms & Conditions</h1>
          <p className="legal-updated">Last updated: January 2024</p>
        </div>

        <div className="legal-content">
          <div className="legal-section">
            <h2>1. Acceptance of Terms</h2>
            <p>
              By downloading, installing, or using the Slink mobile application ("App"), you agree to 
              be bound by these Terms and Conditions. If you do not agree to these terms, please do not 
              use the App.
            </p>
          </div>

          <div className="legal-section">
            <h2>2. Eligibility</h2>
            <ul>
              <li>You must be at least 18 years of age to use this App</li>
              <li>You must provide accurate information during registration</li>
              <li>You are responsible for maintaining the security of your account</li>
              <li>One person may only have one active account</li>
            </ul>
          </div>

          <div className="legal-section">
            <h2>3. Account Registration</h2>
            <p>To use Slink, you must create an account by providing:</p>
            <ul>
              <li>A valid phone number for OTP verification</li>
              <li>A display name</li>
              <li>Your gender, state, and city</li>
              <li>At least one profile photo</li>
            </ul>
            <p>You are responsible for all activities that occur under your account.</p>
          </div>

          <div className="legal-section">
            <h2>4. Platform Services</h2>
            <p>Slink provides the following services:</p>
            <ul>
              <li><strong>Video Calling:</strong> Real-time video calls between users at ₹15 per minute (charged to the caller)</li>
              <li><strong>Messaging:</strong> Text-based chat between users</li>
              <li><strong>Earning System:</strong> Users can earn money by receiving video calls based on their level</li>
              <li><strong>Wallet System:</strong> In-app wallet for payments and earnings</li>
            </ul>
          </div>

          <div className="legal-section warning-box">
            <h2>5. Prohibited Conduct</h2>
            <p>The following activities are strictly prohibited and may result in account suspension or permanent ban:</p>
            <ul>
              <li><strong>Sharing personal contact information</strong> (phone numbers, email, social media) in chat or during calls</li>
              <li>Using fake, misleading, or inappropriate profile photos</li>
              <li>Harassment, abuse, or threatening behavior towards other users</li>
              <li>Nudity, sexually explicit content, or inappropriate behavior during video calls</li>
              <li>Scamming, fraud, or attempting to manipulate the earning system</li>
              <li>Using automated tools, bots, or scripts</li>
              <li>Creating multiple accounts</li>
              <li>Impersonating another person</li>
              <li>Recording, screenshotting, or sharing video calls</li>
              <li>Promoting illegal activities</li>
            </ul>
          </div>

          <div className="legal-section highlight-box">
            <h2>6. Violation & Account Blocking Policy</h2>
            <p><strong>Enforcement process for rule violations:</strong></p>
            <ul>
              <li><strong>First violation:</strong> A warning notice will be sent to the user. The user must acknowledge the violation.</li>
              <li><strong>Second violation:</strong> The user's account will be permanently blocked.</li>
              <li>Blocked accounts lose access to all wallet balance and pending earnings.</li>
              <li>No refunds will be issued for blocked accounts.</li>
              <li>Severe violations (fraud, explicit content) may result in immediate permanent ban without prior warning.</li>
            </ul>
          </div>

          <div className="legal-section">
            <h2>7. Payments & Wallet</h2>
            <ul>
              <li>All payments are processed through Razorpay payment gateway</li>
              <li>Video call charges are ₹15 per minute, deducted from the caller's wallet</li>
              <li>Minimum wallet balance of ₹15 is required to initiate a video call</li>
              <li>Wallet recharges are instant upon successful payment</li>
              <li>All prices are in Indian Rupees (₹/INR)</li>
            </ul>
          </div>

          <div className="legal-section">
            <h2>8. Earning & Withdrawal</h2>
            <ul>
              <li>Users earn a percentage of video call revenue based on their level (10%-40%)</li>
              <li>Levels are unlocked by completing call hours (Level 1: 10h, up to Level 6: 500h)</li>
              <li>Earnings are credited to the in-app wallet after each call</li>
              <li>Withdrawals are processed to registered bank accounts/UPI within 24-48 hours</li>
              <li>Slink reserves the right to hold or reverse earnings if fraudulent activity is detected</li>
            </ul>
          </div>

          <div className="legal-section">
            <h2>9. Video Call Rules</h2>
            <ul>
              <li>Both parties must consent to a video call</li>
              <li>Users may end a call at any time</li>
              <li>Recording or screenshotting video calls is prohibited and technically blocked</li>
              <li>Inappropriate behavior during calls will result in immediate account action</li>
              <li>Call charges begin once the call is connected</li>
            </ul>
          </div>

          <div className="legal-section">
            <h2>10. Intellectual Property</h2>
            <p>
              All content, design, branding, and technology within the Slink App are the intellectual 
              property of Slink and its parent company. You may not copy, modify, distribute, or 
              reverse-engineer any part of the App.
            </p>
          </div>

          <div className="legal-section">
            <h2>11. Limitation of Liability</h2>
            <ul>
              <li>Slink is not responsible for user behavior during calls or chats</li>
              <li>We are not liable for any loss arising from unauthorized access to your account</li>
              <li>We do not guarantee uninterrupted service and are not liable for technical disruptions</li>
              <li>Maximum liability is limited to the amount paid by the user in the last 30 days</li>
            </ul>
          </div>

          <div className="legal-section">
            <h2>12. Termination</h2>
            <p>
              We reserve the right to suspend or terminate your account at any time for violation of 
              these Terms. You may also delete your account at any time from the app settings.
            </p>
          </div>

          <div className="legal-section">
            <h2>13. Governing Law</h2>
            <p>
              These Terms are governed by the laws of India. Any disputes shall be subject to the 
              exclusive jurisdiction of the courts in Kolkata, West Bengal, India.
            </p>
          </div>

          <div className="legal-section">
            <h2>14. Changes to Terms</h2>
            <p>
              We may update these Terms from time to time. Continued use of the App after changes 
              constitutes acceptance of the updated Terms.
            </p>
          </div>

          <div className="legal-section">
            <h2>15. Contact Us</h2>
            <p>For any questions regarding these Terms & Conditions:</p>
            <ul>
              <li>Email: <a href="mailto:slink@astergo.in" className="legal-link">slink@astergo.in</a></li>
              <li>Address: Kolkata, West Bengal, India</li>
            </ul>
          </div>
        </div>
      </div>
    </section>
  );
};

export default TermsConditions;
